import FeaturesCarouselItem from '../featuresCarouselItem/FeaturesCarouselItem';
import React from 'react';
import { Carousel } from '@tme/toyota-common';
import { FeaturesAndCapabilitiesResponsePayloadService } from '../../@types/dataTypes';
import _ from 'lodash';
import { servicesToDisplay } from '../../tools/tools';
import { VinCheckerCSFeaturesLabels } from '../../@types/labelTypes';

type FeaturesCarouselProps = {
	features: FeaturesAndCapabilitiesResponsePayloadService[];
	labels: VinCheckerCSFeaturesLabels;
};
export default function FeaturesCarousel({
	features,
	labels
}: FeaturesCarouselProps): React.JSX.Element {
	return (
		<Carousel
			options={{
				shouldCenterActiveSlide: false,
				spacingBetweenItems: 120,
				addObserver: true,
				addParentsObserve: true,
				carouselInteractionEnabled: true,
				shouldEqualizeSlidesHeight: true,
				useBootstrap5: true
			}}
			navigationOptions={{
				shouldShowArrows: true,
				enableTopArrowNavigation: true
			}}
			breakpointOptions={{
				SM: {
					numberOfSlidesInView: 1
				},
				MD: {
					numberOfSlidesInView: 2
				},
				LG: {
					numberOfSlidesInView: 2
				},
				XL: {
					numberOfSlidesInView: 3
				},
				XXL: {
					numberOfSlidesInView: 3
				}
			}}
			id={`features-carousel`}
		>
			{_.map(servicesToDisplay(features), (feature) => {
				return (
					<FeaturesCarouselItem
						service={feature}
						labels={labels}
						key={`${feature.serviceName}-accordion-item`}
					/>
				);
			})}
		</Carousel>
	);
}
